/** The room code as one tile per character, like the letters on a street sign. */
export function CodeTiles({ code, size = "lg" }: { code: string; size?: "sm" | "lg" }) {
  const tile =
    size === "lg"
      ? "h-14 w-[2.6rem] text-3xl sm:h-20 sm:w-16 sm:text-5xl"
      : "h-11 w-9 text-2xl sm:h-14 sm:w-11 sm:text-3xl";
  return (
    <p aria-label={`Raum-Code ${[...code].join(" ")}`} className="flex gap-1.5 sm:gap-2">
      {[...code].map((char, i) => (
        <span
          key={i}
          aria-hidden="true"
          className={`grid place-items-center rounded-lg border border-line bg-surface font-display font-bold leading-none text-ink shadow-[0_3px_0_var(--line)] ${tile}`}
        >
          {char}
        </span>
      ))}
    </p>
  );
}
